import { SlHome, SlPhone, SlSim } from "@/assets/icons/icons.tsx";
import { SimCardDetail } from "@/services/model";
import {
  getProductCategory,
  getProductIdFromSim,
  ProductCategory,
} from "@/utils/productMatrix";

// ProductCard's header icon is picked by product type (Flat Mobile/Flat
// Home/Flat Data), not by SIM status.
const categoryToIcon: Record<ProductCategory, JSX.Element> = {
  mobile: <SlPhone />,
  home: <SlHome />,
  data: <SlSim />,
};

export const getIconForProductId = (productId?: number): JSX.Element =>
  categoryToIcon[getProductCategory(productId)];

export const getIconForProductCategory = (
  device?: SimCardDetail,
): JSX.Element => getIconForProductId(getProductIdFromSim(device));
